import { AcompanharLista } from './acompanhar/AcompanharLista';
import type { CooperadoAba } from '../types';

interface Props {
  onNavegar?: (aba: CooperadoAba) => void;
}

export function AcompanharAba({ onNavegar }: Props) {
  return <AcompanharLista onEmitir={onNavegar ? () => onNavegar('emitir') : undefined} />;
}
